import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import s from '../content.scss';
import PaperTile from '../../components/PaperTile/PaperTile';
import Link from '../../components/Link/Link';
import PaperHeader from '../../components/PaperHeader/PaperHeader';
import { getCurrentDistrict } from '../../components/utils/utils'

class Euslugi extends React.Component {
  state = {
    filter_text: '',
    categories: [],
    all_service_ids: new Set([]),
    filtered_service_ids: new Set([]),
    serviceCategories: {},
    currentDistrict: null,
    district: null
  };

  componentDidMount() {
    this.setCurrentDistrict();
    this.getServiceCategories();
  }

  setCurrentDistrict() {
    getCurrentDistrict()
    .then((teryt) => {
      let district = null;
      Object.keys(this.props.districts).forEach(key => {
        if (this.props.districts[key].teryt === teryt) {
          district = this.props.districts[key];
        }
      });
      this.setState({ currentDistrict: teryt, district });
    });
  }

  getServiceCategories() {
    let serviceCategories = {};
    const all_service_ids = [];

    const url = `${process.env.API_URL}/eservices/service_categories/`;
    fetch(url)
      .then(r => r.json())
      .then(resp => {
        serviceCategories = resp;
        Object.keys(serviceCategories).map(
          (service) =>
          all_service_ids.push(...serviceCategories[service]),
          );
        this.setState({ serviceCategories, all_service_ids: new Set(all_service_ids), filtered_service_ids: new Set(all_service_ids) });
      });
  }

  serviceFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = e.target.value.replace(/\s\s+/g, ' ');
    this.setState({ filter_text: value });
  };

  categoryFilterChange = (categoryId) => {
    let categories = this.state.categories;
    let filtered_service_ids = this.state.filtered_service_ids;

    if (categories.some(category => category === categoryId)) {
      categories = categories.filter(item => item !== categoryId);
    } else {
      categories.push(categoryId);
    }

    if (categories.length === 0) {
      filtered_service_ids = new Set(this.state.all_service_ids);
    } else {
      const serviceIds = [];
      categories.map(
        (category) =>
        serviceIds.push(...this.state.serviceCategories[category]),
        );
        filtered_service_ids = new Set(serviceIds);
    }
    this.setState({ categories, filtered_service_ids });
  };

  renderServicesList = (title, servicesList) => {
    return (
      <div className="col-lg-12">
        <PaperHeader title={title} text="" />
        {servicesList.map(
        (service, i) =>
            <Col key={`${i}service1`} xs={12} sm={6} md={4}>
              <PaperTile
                wkLogin={this.state.district && this.state.district.wkLogin}
                href={`eservices?district=${this.state.currentDistrict}&serviceType=${service}`}
                text={this.props.eservices[service].title} epuap={this.props.eservices[service].requiresEPUAP} />
            </Col>,
          )}
      </div>
    );
  };

  render() {
    // const customerId = 'E819A999-4CAF-45D1-AF89-A38628EBFF6F'; // testowy eboi
    const firstService = this.props.eservices && Object.keys(this.props.eservices).filter(
            service => service === 'SprDostMaterialow' && this.props.eservices[service].isEnabled === true &&
              this.props.eservices[service].title.toLowerCase().includes(this.state.filter_text.toLowerCase()) &&
              this.state.filtered_service_ids.has(this.props.eservices[service].id));
    const servicesWithoutLogging = this.props.eservices && Object.keys(this.props.eservices).filter(
            service => this.props.eservices[service].requiresUserInfo === false &&
            this.props.eservices[service].isEnabled === true &&
            this.props.eservices[service].title.toLowerCase().includes(this.state.filter_text.toLowerCase()) &&
            this.state.filtered_service_ids.has(this.props.eservices[service].id) && service !== 'SprDostMaterialow')
            .sort().reverse();
    const servicesWithLogging = this.props.eservices && Object.keys(this.props.eservices).filter(
            service => this.props.eservices[service].requiresUserInfo === true &&
            this.props.eservices[service].isEnabled === true &&
            this.props.eservices[service].title.toLowerCase().includes(this.state.filter_text.toLowerCase()) &&
        this.state.filtered_service_ids.has(this.props.eservices[service].id) && service !== 'SprDostMaterialow');

    return (
      <div>
        <div className="row" style={{ margin: '20px auto 50px auto' }}>
          {/* <div className="row" style={{ padding: '5px 0', margin: '15px 0' }}>
            <ServicesCategories onChange={this.categoryFilterChange} />
          </div> */}
          <Col xs={12} sm={6} md={4}>
          {firstService ? firstService.map((service, i) =>
              <div key={`${i}service1`}>
              <PaperTile
                  wkLogin={this.state.district && this.state.district.wkLogin}
                  href={`eservices?district=${this.state.currentDistrict}&serviceType=${service}`}
                  text={this.props.eservices[service].title} epuap={this.props.eservices[service].requiresEPUAP} />
              </div>,
            ) : null}
          {servicesWithLogging ? servicesWithLogging.map((service, i) =>
              <div key={`${i}service1`}>
              <PaperTile
                  wkLogin={this.state.district && this.state.district.wkLogin}
                  href={`eservices?district=${this.state.currentDistrict}&serviceType=${service}`}
                  text={this.props.eservices[service].title} epuap={this.props.eservices[service].requiresEPUAP} />
              </div>,
            ) : null}
            {servicesWithoutLogging ? servicesWithoutLogging.map((service, i) =>
              <div key={`${i}service1`}>
                <PaperTile
                  wkLogin={this.state.district && this.state.district.wkLogin}
                  href={`eservices?district=${this.state.currentDistrict}&serviceType=${service}`}
                  text={this.props.eservices[service].title} epuap={this.props.eservices[service].requiresEPUAP} />
              </div>,
            ) : null}
          </Col>
          <Col xs={12} sm={6} md={8}>
            <PaperHeader title="Karta e-usług" text="" />
            <div style={{ padding: '0 1em' }}>
              <h4>Sposób odwołania</h4>
              <p>
                Nie dotyczy
              </p>
              <h4>
                Opłaty
              </h4>
              <p>
                Na podstawie załacznika do ustawy z&nbsp;dnia 17 maja 1989&nbsp;r. — Prawo geodezyjne 
                i&nbsp;kartograficzne o&nbsp;wysokości stawek podstawowych w&nbsp;odniesieniu do odpowiednich 
                jednostek rozliczeniowych, wysokości współczynników korygujących 
                oraz zasad ustalania tych współczynników, a&nbsp;także szczegółowe zasady obliczania 
                wysokości opłaty, w&nbsp;tym opłaty zryczałtowanej.
              </p>
              <h4>
                Podstawa prawna
              </h4>
              <ul>
                <li>
                  art. 40a ust. 1 ustawy z&nbsp;dnia 17 maja 1989&nbsp;r. Prawo geodezyjne i&nbsp;kartograficzne 
                  (Dz.&nbsp;U. z&nbsp;2021&nbsp;r. poz.&nbsp;1990 t.j.)
                </li>
                <li>
                  Rozporządzenie Ministra Administracji i&nbsp;Cyfryzacji w&nbsp;sprawie organizacji 
                  i&nbsp;trybu prowadzenia państwowego zasobu geodezyjnego i&nbsp;kartograficznego 
                  z&nbsp;dnia 5&nbsp;września 2013&nbsp;r. (Dz.U. z&nbsp;2013&nbsp;r. poz.&nbsp;1183)
                </li>
                <li>
                  Rozporządzenie ministra rozwoju w&nbsp;sprawie wzorów wniosków o&nbsp;udostępnienie 
                  materiałów państwowego zasobu geodezyjnego i&nbsp;kartograficznego, 
                  licencji i&nbsp;Dokumentu Obliczenia Opłaty, 
                  a&nbsp;także sposobu wydawania licencji z&nbsp;dnia 28 lipca 2020&nbsp;r. (Dz.&nbsp;U. z&nbsp;2020&nbsp;r. poz.&nbsp;1322)
                </li>
              </ul>
              {servicesWithLogging ? <Link className="btn btn-warning pull-right" to={`eservices?district=${this.state.currentDistrict}&serviceType=${servicesWithLogging[0]}`}>Przejdź do formularza</Link> : null}
            </div>
          </Col>
        </div>
      </div>
    );
  }
}
const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts,
  fontSize: state.runtime.fontSize,
});

export default withStyles(s)(connect(mapState)(Euslugi));



// WEBPACK FOOTER //
// src/routes/euslugi/Euslugi.js